import { Inject, Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { filter, map, of, switchMap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SettingsActions } from './settings.action';
import { DOCUMENT } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectFontSize, selectLanguage } from './settings.reducers';
import { MainComponentActions } from '../main.actions';
import { Cookies, getCookie } from '../../../utils/cookies';

@Injectable({
  providedIn: 'root',
})
export class SettingsEffects {
  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private store: Store,
    @Inject(DOCUMENT) private document: Document
  ) {}

  setFont$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          SettingsActions.setFontSize,
          MainComponentActions.mainComponentLoaded
        ),
        switchMap(() => this.store.select(selectFontSize)),
        map((fontSize) => {
          this.document.body.style.fontSize = fontSize;
        })
      ),
    { dispatch: false }
  );

  setLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SettingsActions.setLanguage),
      filter((action) => action.value !== this.translateService.currentLang),
      switchMap(({ value: language }) => this.translateService.use(language)),
      switchMap(() => {
        const language = this.translateService.currentLang;
        return of(SettingsActions.setLanguageSuccess({ language }));
      })
    )
  );

  setLanguageOnLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MainComponentActions.mainComponentLoaded),
      concatLatestFrom(() => this.store.select(selectLanguage)),
      switchMap(([, language]) => this.translateService.use(language || 'en')),
      switchMap(() => {
        const language = this.translateService.currentLang;
        const cookieLanguage = getCookie(Cookies.LANGUAGE);
        if (cookieLanguage != language) {
          return of(SettingsActions.setLanguage({ value: cookieLanguage }));
        }
        return of(SettingsActions.setLanguageSuccess({ language }));
      })
    )
  );
}
